import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, TrendingUpIcon, HomeIcon } from 'lucide-react';
const benefits = [{
  id: 1,
  title: 'Guía Paso a Paso',
  description: 'Aprendé de forma clara y ordenada cómo empezar tu negocio online desde cero, incluso si hoy no tenés experiencia.',
  icon: BookOpenIcon,
  color: 'text-blue-600',
  bgColor: 'bg-blue-50',
  borderColor: 'border-blue-100'
}, {
  id: 2,
  title: 'Estrategias Probadas',
  description: 'Conocé métodos y estrategias que ya funcionan en el mercado argentino para generar ingresos en internet.',
  icon: TrendingUpIcon,
  color: 'text-emerald-600',
  bgColor: 'bg-emerald-50',
  borderColor: 'border-emerald-100'
}, {
  id: 3,
  title: 'Independencia Total',
  description: 'Descubrí cómo crear una fuente de ingresos propia y empezar a construir tu independencia económica.',
  icon: HomeIcon,
  color: 'text-indigo-600',
  bgColor: 'bg-indigo-50',
  borderColor: 'border-indigo-100'
}];
export function BenefitsSection() {
  return <section className="py-20 bg-slate-50 relative" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-heading font-bold text-slate-900 mb-4" data-id="element-4">
            ¿Qué vas a encontrar en Emprende Digital?
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-slate-600" data-id="element-5">
            Todo lo que necesitás para empezar tu negocio digital desde cero.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="w-24 h-1 bg-gradient-to-r from-brand-blue to-brand-green mx-auto mt-6 rounded-full" data-id="element-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={benefit.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className={`bg-white rounded-2xl p-8 shadow-soft border ${benefit.borderColor} hover:shadow-lg transition-shadow duration-300 relative overflow-hidden group`} data-id="element-8">
                <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-transparent to-black opacity-[0.02] rounded-bl-full transform translate-x-8 -translate-y-8 group-hover:scale-110 transition-transform duration-500`} data-id="element-9" />

                <div className={`w-14 h-14 rounded-xl ${benefit.bgColor} flex items-center justify-center mb-6`} data-id="element-10">
                  <Icon className={`w-7 h-7 ${benefit.color}`} data-id="element-11" />
                </div>

                <h3 className="text-xl font-heading font-semibold text-slate-900 mb-3" data-id="element-12">
                  {benefit.title}
                </h3>

                <p className="text-slate-600 leading-relaxed" data-id="element-13">
                  {benefit.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}